@if (mascotMode() === 'model') {
  <model-viewer
    #robocatMv
    class="mascot-model-viewer"
    src="/public/model/robocat.glb"
    alt=""
    camera-orbit="0deg 75deg 105%"
    camera-controls="false"
    interaction-prompt="none"
    disable-tap
    shadow-intensity="0.5"
    exposure="1"
  ></model-viewer>
} @else {
  <img
    class="mascot-fallback"
    src="/public/svgs/robocat.svg"
    alt=""
  />
}
